import reducer from './reducer';
import { createStore } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { toast } from 'react-toastify';

const persistConfig = {
    key: 'locasmartpro',
    storage,
    writeFailHandler: (err: any) => {
        console.error('Falha ao persistir token:', err);
        toast.error('Erro ao realizar login: Fale com o suporte do LocaSmartPro')
    },
}

const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };

export type State = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch